import React from "react";
import PropTypes from "prop-types";

const ArrowBottomLeft = ({ className, color }) => {
  switch (color) {
    case `bone`:
      color = `#f4eee3`;
      break;

    default:
      break;
  }

  //

  return (
    <svg className={className} viewBox="0 0 31.11 29.86">
      <g id="Layer_5" data-name="Layer 5">
        <path
          d="M31.11,1.28A9.6,9.6,0,0,0,28.58.94a10,10,0,0,0-10,10v1.39a10.91,10.91,0,0,1-10.9,10.9H3.19l-1.31,0a13.32,13.32,0,0,1,5.18,5.92l0,.1-.67.67-.09-.21A12.08,12.08,0,0,0,.09,23.2l0,0,0,0v-.87H0l0,0,.15-.07a12.13,12.13,0,0,0,6.2-6.5l.09-.21.67.68,0,.1a13.37,13.37,0,0,1-5.15,6l1.25,0H7.72a10,10,0,0,0,10-10V10.9A10.91,10.91,0,0,1,28.58,0a10.5,10.5,0,0,1,2.53.31Z"
          stroke={color}
        />
      </g>
    </svg>
  );
};

ArrowBottomLeft.defaultProps = {
  className: ``,
  color: `#ffffff`
};

ArrowBottomLeft.propTypes = {
  className: PropTypes.string,
  color: PropTypes.string
};

export default ArrowBottomLeft;
